import React, { useEffect, useRef, useState } from "react";
import "./SettingsStyles.css";
import CardLayout from "../../common/cardLayout/CardLayout";
import PillButton from "../../common/PillButton";
import { ReactComponent as PencilIcon } from "../../../assets/icons/Pencil.svg";
import eyeopen from "../../../assets/icons/eye-open.svg";
import eyeclose from "../../../assets/icons/EyeClose.svg";
import { changePasswordLogic } from "../../../store/features/app/appSlice";
import { getFullName, getInitials, notify } from "../../../util/helpers";
import { useSelector } from "react-redux";

const ChangePassword = (props) => {
  const [passwordFieldOldValue, setPasswordFieldOld] = useState("");
  const [passwordFieldNewValue, setPasswordFieldNew] = useState("");
  const [passwordFieldConfirmValue, setPasswordFieldConfirm] = useState("");
  const { user } = useSelector((state) => state.app);
  const fullname = getFullName(user);
  const handleSubmit = async (e) => {
    e.preventDefault();

    changePasswordLogic({
      old_password: passwordFieldOldValue,
      new_password: passwordFieldNewValue,
    })
      .then((res) => {
        if (res.status === 200) {
          notify("Password updated successfully");
        } else {
          notify("Something went wrong...", "error");
        }
      })
      .catch((error) => {
        notify("Something went wrong...", "error");
      });
  };
  const [disabled, setDisabled] = useState(true);

  const passwordFieldOld = useRef();
  const passwordFieldNew = useRef();
  const passwordFieldConfirm = useRef();

  const passwordIconOld = useRef();
  const passwordIconNew = useRef();
  const passwordIconConfirm = useRef();

  const handleDisabled = () => {
    if (
      passwordFieldOldValue.length >= 8 &&
      passwordFieldNewValue.length &&
      passwordFieldConfirmValue.length
    ) {
      if (passwordFieldNewValue === passwordFieldConfirmValue) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    } else {
      setDisabled(true);
    }
  };
  useEffect(() => {
    handleDisabled();
  }, [passwordFieldOldValue, passwordFieldNewValue, passwordFieldConfirmValue]);
  const toggleVisibility = (reference, iconReference) => {
    if (reference.current.type === "password") {
      reference.current.type = "text";
      iconReference.current.src = eyeclose;
    } else {
      reference.current.type = "password";
      iconReference.current.src = eyeopen;
    }
  };

  return (
    <CardLayout>
      <div className="container-fluid d-flex justify-content-start w-100 py-3">
        <h5 className="muted-text">Change Password</h5>
      </div>
      <div className="d-flex justify-content-center">
        <div className="container">
          <img
            src={`https://placehold.co/150x150/f1f1f5/395E9D/?text=${getInitials(
              fullname
            )}`}
            style={{
              borderRadius: "100%",
              display: "block",
              marginBottom: "5%",
            }}
          />
          <PillButton
            text={"Change Picture"}
            icon={
              <PencilIcon style={{ marginLeft: "4px", marginTop: "-4px" }} />
            }
            handleClick={() => {}}
          />
        </div>
      </div>
      <form onSubmit={handleSubmit} className="container-fluid">
        <div className="form-group my-3">
          <label>Current Password</label>
          <div style={{ position: "relative" }}>
            <input
              type="password"
              placeholder="Your Password"
              ref={passwordFieldOld}
              value={passwordFieldOldValue}
              onChange={(e) => {
                setPasswordFieldOld(e.target.value);
              }}
            />
            <img
              src={eyeopen}
              ref={passwordIconOld}
              onClick={() => {
                toggleVisibility(passwordFieldOld, passwordIconOld);
              }}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
              }}
              alt="Show Password"
              height="25px"
              width="25px"
            />
          </div>
        </div>
        <div className="form-group my-3">
          <label>New Password</label>
          <div style={{ position: "relative" }}>
            <input
              type="password"
              placeholder="Your New Password"
              ref={passwordFieldNew}
              value={passwordFieldNewValue}
              onChange={(e) => {
                setPasswordFieldNew(e.target.value);
              }}
            />
            <img
              src={eyeopen}
              ref={passwordIconNew}
              onClick={() => {
                toggleVisibility(passwordFieldNew, passwordIconNew);
              }}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
              }}
              alt="Show Password"
              height="25px"
              width="25px"
            />
          </div>
        </div>
        <div className="form-group my-3">
          <label>Confirm Password</label>
          <div style={{ position: "relative" }}>
            <input
              type="password"
              placeholder="Confirm Your Password"
              ref={passwordFieldConfirm}
              value={passwordFieldConfirmValue}
              onChange={(e) => {
                setPasswordFieldConfirm(e.target.value);
              }}
            />
            <img
              src={eyeopen}
              ref={passwordIconConfirm}
              onClick={() => {
                toggleVisibility(passwordFieldConfirm, passwordIconConfirm);
              }}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
              }}
              alt="Show Password"
              height="25px"
              width="25px"
            />
          </div>
        </div>
        <div className="container-fluid d-flex justify-content-end my-5">
          <button type="submit" disabled={disabled} className="btn primary-btn">
            Save Changes
          </button>
        </div>
      </form>
    </CardLayout>
  );
};

export default ChangePassword;
